// Header.jsx
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Search, Menu, Plus } from 'lucide-react';
import NotificationsDropdown from './NotificationsDropdown';
import useNotifications, { requestNotificationPermission } from '../hooks/useNotifications';
import { fetchUnreadCount } from '../features/notifications/notificationSlice';

const Header = () => {
  const dispatch = useDispatch();
  
  // Initialize WebSocket connection
  useNotifications();

  // Request notification permission and fetch unread count on mount
  useEffect(() => {
    requestNotificationPermission();
    // Fetch initial unread count
    dispatch(fetchUnreadCount());
  }, [dispatch]);

  return (
    <header className="header">
      <div className="logo">
        <img src="/banner/logo.png" alt="Logo" />
      </div>

      {/* Search Section */}
      <div className="search-container">
        <div className="search-wrapper">
          <Search className="search-icon" />
          <input
            type="text"
            placeholder="Try searching 'insights'"
            className="search-input"
          />
        </div>
      </div>

      {/* Right Section */}
      <div className="actions">
        <button className="menu-button">
          <Menu className="menu-icon" />
        </button>
        
        {/* Notifications */}
        <NotificationsDropdown />
        
        <div className="avatar"></div>
        
       
      </div>

      <style jsx>{`
        .header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;
          background: transparent;
          width: 100%;
          box-sizing: border-box;
        }
          
        .logo img {
          width: 98px;
        }

        .search-container {
          flex: 1;
          max-width: 400px;
        }

        .search-wrapper {
          width: 100%;
          position: relative;
        }

        .search-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          width: 16px;
          height: 16px;
          color: #9ca3af;
        }

        .search-input {
          width: 100%;
          padding: 8px 16px 8px 40px;
          background: #fff;
          border-radius: 20px;
          font-size: 14px;
          border: 1px solid #e5e7eb;
        }

        .search-input:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
        }

        .actions {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .menu-button {
          padding: 8px;
          border: none;
          background: transparent;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .menu-button:hover {
          background: #f3f4f6;
        }

        .menu-icon {
          width: 20px;
          height: 20px;
          color: #4b5563;
        }

        .avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: linear-gradient(to right, #60a5fa, #2dd4bf);
        }

        .add-button {
          padding: 8px;
          border: none;
          background: #f43f5e;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background-color 0.2s;
        }

        .add-button:hover {
          background: #e11d48;
        }

        .plus-icon {
          width: 20px;
          height: 20px;
          color: white;
        }
      `}</style>
    </header>
  );
};

export default Header;